import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import type { FindFinishedInvoices, PaginatedInvoice } from "contracts/Invoice";
import type { Pagination } from "contracts/Pagination";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess", "onFailure"],
    success: ["data", "pagination"],
    failure: ["errorMessage"],
    softReset: [],
    reset: [],
  },
  {
    prefix: "PAGINATE_FINISHED_INVOICES_",
  }
);

export interface PaginateFinishedInvoicesState {
  data: PaginatedInvoice[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateFinishedInvoicesRequestAction {
  query?: FindFinishedInvoices;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedInvoice[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateFinishedInvoicesState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateFinishedInvoicesState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: PaginateFinishedInvoicesState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (state: PaginateFinishedInvoicesState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateFinishedInvoicesState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = (state: PaginateFinishedInvoicesState) =>
  update(state, {
    data: { $set: {} },
  });

export const paginateFinishedInvoices = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateFinishedInvoicesTypes = Types;
export const PaginateFinishedInvoicesActions = Creators;
